<template>
	<div class="voice" @click="play()" v-bind:class="{ 'self-voice': isSelf }" v-bind:style="{ width: voiceWidth + 'px' }">
		<i class="iconfont icon-voice" v-bind:class="{ playing: playing }" />
		<span>{{ length }}"</span>
	</div>
</template>

<script>
import { play } from "@/services/player/player";

export default {
	name: "MessageVoice",

	props: {
		id: {
			type: String,
			required: true,
		},
		attachmentUrl: {
			type: String,
			required: true,
		},
		length: {
			type: Number,
			required: true,
		},
		isSelf: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			playing: false,
		};
	},

	methods: {
		play() {
			const player = play(this.attachmentUrl, this.id);

			player.onpause = () => {
				this.playing = false;
			};

			player.onplay = () => {
				this.playing = true;
			};

			player.onerror = () => {
				this.playing = false;
				this.$message({
					message: this.$t("chatMessageVoice.voiceIsCorrupted"),
					type: "error",
				});
			};
		},
	},

	computed: {
		voiceWidth: function () {
			return this.length * 5 + 60;
		},
	},
};
</script>

<style lang="less" scoped>
.voice {
	display: flex;
	gap: 5px;
	width: 100px;
	max-width: 300px;
	cursor: pointer;

	.playing {
		animation: blink 1s infinite;
		-webkit-animation: blink 1s infinite;
	}
}

.self-voice {
	flex-direction: row-reverse;

	i {
		transform: rotate(-180deg);
	}
}

@keyframes blink {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 100;
	}
	100% {
		opacity: 0;
	}
}

@-webkit-keyframes blink {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 100;
	}
	100% {
		opacity: 0;
	}
}
</style>
